import * as React from 'react';
import { MonthWithCardGroup } from '../utils';
import { localedFormat } from '../../../utils';
import CardsGroup from './CardsGroup/CardsGroup';
import './Month.css';
import '../../Calendar/Week/Month/Month.css';
import { getMonth, isSameMonth, startOfMonth, endOfDay, endOfMonth } from 'date-fns';
import cn from 'classnames';

interface Props {
	month: MonthWithCardGroup;
	changeFocusedMonth?: (month: Date) => void;
	focused?: boolean;
}

const Month: React.FC<Props> = props => {
	const monthHeaderRef = React.useRef<HTMLDivElement>(null);
	const monthHeaderWrapperRef = React.useRef<HTMLDivElement>(null);

	const onScroll = (event: any) => {
		const divHeight = monthHeaderWrapperRef.current.offsetHeight;
		const offsetTop = monthHeaderWrapperRef.current.offsetTop;

		if ((window.scrollY > offsetTop && window.scrollY < divHeight + offsetTop )&& !props.focused) {
			props.changeFocusedMonth(props.month.month);
		}
	};

	React.useEffect(() => {
		window.addEventListener('scroll', onScroll);

		return () => {
			window.removeEventListener('scroll', onScroll);
		}
	});

	const monthNumber = getMonth(props.month.month);

	const startMonth = startOfMonth(props.month.month);
	const endMonth = endOfMonth(props.month.month);

	return (
		<div ref={monthHeaderWrapperRef} id={`month-${props.month.month.getMonth()}`}>
			<div className={cn("mobile-calendar-month__headerWrapper")}>
				<div
					className={cn("mobile-calendar-month__header", "month", {
						month_winter:
							(monthNumber >= 0 && monthNumber <= 1) || monthNumber == 11,
						month_spring: monthNumber >= 2 && monthNumber <= 4,
						month_summer: monthNumber >= 5 && monthNumber <= 7,
						month_autumn: monthNumber >= 8 && monthNumber <= 10,
					})}
					ref={monthHeaderRef}
					style={{ zIndex: monthNumber }}
				>
					{localedFormat(props.month.month, "LLLL")}

					{props.month.endMonth &&
					!isSameMonth(props.month.month, props.month.endMonth)
						? ` - ${localedFormat(props.month.endMonth, "LLLL")}`
						: ""}
				</div>
			</div>

			<div>
				{props.month.cardsGroup.map((cardGroup, key) => (
					<CardsGroup cardsGroup={cardGroup} key={key} />
				))}

				{props.month.cardsGroup.length === 0 && (
					<CardsGroup
						cardsGroup={{
							startDate: startMonth.getDate(),
							endDate: endMonth.getDate(),
							cards: [
								{
									startDate: startMonth,
									endDate: endMonth,
									card: null,
									type: null,
								},
							],
						}}
						isEmpty={true}
					/>
				)}
			</div>
		</div>
	);
};

export default Month;
